import React from "react";
import { ReactNotifications, Store } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";

class Notification extends React.Component {
  notify(title, message, type, container, duration) {
    Store.addNotification({
      title: title || "",
      message: message || "",
      type: type || "",
      insert: "top",
      container: container ? container : "bottom-right",
      // animationIn: ["animated", "bounceIn"],
      // animationOut: ["animated", "bounceOut"],
      animationIn: ["animate__animated", "animate__fadeIn"],
  animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: { 
        duration: duration ? duration : 3000,
        click: true 
      },
    });
  }
  
  render() {
    return (
      <div>
        <ReactNotifications />
      </div>
    );
  }
}

export default Notification;
